/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCharactersCharacterIdContractsContractIdItemsNotFound
 */
export interface GetCharactersCharacterIdContractsContractIdItemsNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCharactersCharacterIdContractsContractIdItemsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdContractsContractIdItemsNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdContractsContractIdItemsNotFound(value: object): value is GetCharactersCharacterIdContractsContractIdItemsNotFound {
    return true;
}

export function GetCharactersCharacterIdContractsContractIdItemsNotFoundFromJSON(json: any): GetCharactersCharacterIdContractsContractIdItemsNotFound {
    return GetCharactersCharacterIdContractsContractIdItemsNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdContractsContractIdItemsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdContractsContractIdItemsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdContractsContractIdItemsNotFoundToJSON(json: any): GetCharactersCharacterIdContractsContractIdItemsNotFound {
    return GetCharactersCharacterIdContractsContractIdItemsNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdContractsContractIdItemsNotFoundToJSONTyped(value?: GetCharactersCharacterIdContractsContractIdItemsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

